module.exports = __webpack_public_path__ + "img/default.4facfe8a.svg";